export const Forms = {
    INITIAL: 0,
};

export const Screens = {
    MAIN: 0, //Quote
    QUOTES: 1,
    ARTICLES: 2,
};

export const AnimationColors = {
    backGroundColor: "#90B5FA",
    primaryColor: "white",
    secondaryColor: "#346E73"
};